export const sorting = {
    'sort.newest': 'Новые',
    'sort.price': 'Цена',
    'sort.on.sale': 'В продаже',
    'sort.number': 'Номер',
}
